// Pool unrounded goals on identical fixtures; never average individual quotients.
export const comparisonPair = (g, source) => {
  const p = source === "real" ? g.goals : source === "should" ? g.should
    : source === "xgoals" ? (g.external_xgoals?.kind === "should_goals_substitute" ? null : g.external_xgoals)
    : source === "result" ? g.result?.xg : source === "statistics" ? g.statistics_model?.xg
    : g.market?.quality === "verified" ? g.market.xg : null;
  return p && [p.home,p.away].every(v => typeof v === "number" && Number.isFinite(v) && v >= 0) ? p : null;
};
export function comparisonGames(games, teamId, before, limit = null) {
  const cutoff = Date.parse(before);
  const selected = games.filter(g => g.final && Date.parse(g.kickoff) < cutoff &&
    [g.home_team_id,g.away_team_id].map(Number).includes(Number(teamId)))
    .sort((a,b) => Date.parse(b.kickoff)-Date.parse(a.kickoff) || Number(b.id)-Number(a.id));
  return limit === null ? selected : selected.slice(0,limit);
}
export function comparisonValue(games, teamId, source, field) {
  const venue = field.endsWith("_home") ? "home" : field.endsWith("_away") ? "away" : null;
  const selected = games.filter(g => !venue || Number(g[venue+"_team_id"]) === Number(teamId));
  const valid = selected.filter(g => comparisonPair(g,source));
  let own=0,against=0;
  for (const g of valid) { const p=comparisonPair(g,source), home=Number(g.home_team_id)===Number(teamId); own+=home?p.home:p.away; against+=home?p.away:p.home; }
  const n=valid.length;
  const value=!n ? null : field === "total_strength" ? (against>0?own/against:null)
    : field === "total_goals" ? (own+against)/n : (field.startsWith("against")?against:own)/n;
  return {value,count:n,selected:selected.length,ids:valid.map(g=>g.id)};
}
export function comparisonDirection(games, teamId, source, field) {
  if (["result","statistics"].includes(source) || field === "total_goals") return [];
  return ["result","statistics"].map(model=>{
    const matched=games.filter(g=>comparisonPair(g,source)&&comparisonPair(g,model));
    const observed=comparisonValue(matched,teamId,source,field);
    const expected=comparisonValue(matched,teamId,model,field);
    const delta=observed.value == null || expected.value == null ? null : observed.value-expected.value;
    return {model,...observed,expected:expected.value,delta,favorable:delta == null ? null : (field.startsWith("against")?-delta:delta)};
  });
}
